import axios from 'axios';

const legacy = axios.create({
  baseURL: `https://slot.tizeti.com/geniatechapi`,
});
export default legacy;
